import { Provider } from '@angular/core';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const APP_INITIALIZER_MAT_FORM_FIELD_DEFAULT_OPTIONS_PROVIDER: Provider[] =
  [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic',
      },
    },
  ];
